/**
 * Per-user dismiss state for dashboard site announcements.
 */

const DISMISS_PREFIX = 'bhg-announcement-dismissed';

function dismissKey(userId: string, announcementId: string): string {
  return `${DISMISS_PREFIX}:${userId}:${announcementId}`;
}

export function isAnnouncementDismissed(userId: string, announcementId: string): boolean {
  try {
    return localStorage.getItem(dismissKey(userId, announcementId)) === '1';
  } catch {
    return false;
  }
}

export function setAnnouncementDismissed(userId: string, announcementId: string): void {
  try {
    localStorage.setItem(dismissKey(userId, announcementId), '1');
  } catch {
    // ignore
  }
}

/** Per-browser dismiss for public landing announcements (no sign-in). */
const LANDING_DISMISS_PREFIX = 'bhg-landing-announcement-dismissed';

function landingDismissKey(announcementId: string): string {
  return `${LANDING_DISMISS_PREFIX}:${announcementId}`;
}

export function isLandingAnnouncementDismissed(announcementId: string): boolean {
  try {
    return localStorage.getItem(landingDismissKey(announcementId)) === '1';
  } catch {
    return false;
  }
}

export function setLandingAnnouncementDismissed(announcementId: string): void {
  try {
    localStorage.setItem(landingDismissKey(announcementId), '1');
  } catch {
    // ignore
  }
}
